// Slugify mirrors backend/scripts/generate_packshots.py.
export const packshotSlug = (name) => name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

// Set of product slugs that actually have AI-generated packshot files under /packshots/.
// Only these will attempt to load an image; the rest fall back to the letter tile.
export const PACKSHOT_SLUGS = new Set([
  "ade-max","admawel","altixum","atrow","aziromycin","bixrex","camroid","caner",
  "ceftrix","cipra","dibavac","difunol","irowan","lacpril","nolcer","rozwan","sartiwan",
]);

export const hasPackshotImage = (name) => PACKSHOT_SLUGS.has(packshotSlug(name));
export const packshotUrl = (name) => `/packshots/${packshotSlug(name)}.png`;
